import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class StakeholdersService extends Service{

  protected url: string = this.dominio+"/adm/laudos-cd/stakeholders/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-stakeholders/stakeholders.service.ts